module.exports = __webpack_public_path__ + "static_portal/img/setting_video_limits.c36ca313.jpg";